// extracted by mini-css-extract-plugin
export default {"about":"About_about__jmFay","title":"About_title__8rNG+","content":"About_content__n0S4e","text":"About_text__6Nrg-","image":"About_image__vcMqz"};